<template>
  <div
    v-if="!closedByUserRecently"
    class="welcome-message-wrapper"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    @click="$emit('click')"
  >
    <div class="welcome-message-close-wrapper">
      <button
        v-show="isShowingCloseWelcomeMessage"
        type="button"
        class="button welcome-message-close"
        @click.stop="onCloseClicked"
      >
        <svg
          viewBox="0 0 20 20"
          width="8"
          class="ma"
          fill="white"
        >
          <use
            xlink:href="#icon-close"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          />
        </svg>
      </button>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="welcome-message" v-html="sanitizedDescription" />
    <!-- eslint-enable -->
    <div class="triangle-wrapper">
      <div class="triangle" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { createGrowthImpression } from '../../../common/api/chatchampApi'

import { linkify, sanitizedMarkup } from '../../../common/utils'
import postMessageMixin from '../../mixins/postMessageMixin'

export default {
  mixins: [postMessageMixin],
  props: {
    message: {
      default: () => {
        return { description: '' }
      },
      type: Object
    }
  },
  data () {
    return {
      isHovering: false
    }
  },
  computed: {
    ...mapState(['channel', 'customerId', 'subscriberId', 'parentUrl', 'device']),
    ...mapGetters(['closedByUserRecently']),
    isShowingCloseWelcomeMessage () {
      if (window.document.body.classList.contains('is-mobile')) return true

      return this.isHovering
    },
    sanitizedDescription () {
      return linkify(sanitizedMarkup(this.message.description, this.message.id), this.message.id)
    }
  },
  mounted () {
    if (this.message.id) {
      this.$store.dispatch('welcomeMessageShownById', this.message.id)
      createGrowthImpression(this.customerId, this.subscriberId, this.message.id, this.parentUrl, this.device)
    }
  },
  methods: {
    onMouseEnter () {
      this.isHovering = true
    },
    onMouseLeave () {
      this.isHovering = false
    },
    onCloseClicked () {
      this.$store.dispatch('welcomeMessageClosed')
      this.notifyWelcomeMessageClosed()
    }
  }
}
</script>

<style src="./welcome-message.scss" />
